import { createFileRoute } from '@tanstack/react-router';

import { routeMetadata } from '@/app/lib/tanstack-router';
import SettingsPage from '@/settings/pages';

export const Route = createFileRoute('/settings/_layout/')({
  head: () => ({
    meta: routeMetadata('Settings')
  }),
  component: SettingsRoute,
  staticData: {
    headerSection: null
  }
});

function SettingsRoute() {
  return <SettingsPage/>;
}
